/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateWearablePermissionAuditLogDto,
} from '../models/index';
import {
    CreateWearablePermissionAuditLogDtoFromJSON,
    CreateWearablePermissionAuditLogDtoToJSON,
} from '../models/index';

export interface WearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebugRequest {
    patientId: string;
    createWearablePermissionAuditLogDto: CreateWearablePermissionAuditLogDto;
}

/**
 * 
 */
export class ActivityDebugApi extends runtime.BaseAPI {

    /**
     */
    async wearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebugRaw(requestParameters: WearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling wearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebug().'
            );
        }

        if (requestParameters['createWearablePermissionAuditLogDto'] == null) {
            throw new runtime.RequiredError(
                'createWearablePermissionAuditLogDto',
                'Required parameter "createWearablePermissionAuditLogDto" was null or undefined when calling wearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebug().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['patientId'] != null) {
            queryParameters['patientId'] = requestParameters['patientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/activity/debug/wearable-permission-audit-logs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWearablePermissionAuditLogDtoToJSON(requestParameters['createWearablePermissionAuditLogDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async wearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebug(requestParameters: WearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.wearablePermissionAuditLogDebugControllerCreateWearablePermissionAuditLogDebugRaw(requestParameters, initOverrides);
    }

}
